import React, { useEffect } from "react";
import Slider from "react-slick";

import c1 from "../../Assets/imagesv2/desktop/new1.webp";
import c2 from "../../Assets/imagesv2/desktop/new2.webp";
import c3 from "../../Assets/imagesv2/desktop/new3.webp";
import c4 from "../../Assets/imagesv2/desktop/new4.webp";
import c5 from "../../Assets/imagesv2/desktop/new5.webp";
import c6 from "../../Assets/imagesv2/desktop/carousel1.webp";
import c7 from "../../Assets/imagesv2/desktop/carousel2.webp";
import c8 from "../../Assets/imagesv2/desktop/carousel7.webp";

import m1 from "../../Assets/imagesv2/Mobile/new1.webp";
import m2 from "../../Assets/imagesv2/Mobile/new2.webp";
import m3 from "../../Assets/imagesv2/Mobile/new3.webp";
import m5 from "../../Assets/imagesv2/Mobile/new5.webp";
import m6 from "../../Assets/imagesv2/Mobile/carousel4.webp";
import m7 from "../../Assets/imagesv2/Mobile/carousel5.webp";
import m8 from "../../Assets/imagesv2/Mobile/carousel3.webp";
import m4 from "../../Assets/imagesv2/Mobile/carousel2.webp";

import "./Carousel.css";
import { Container } from "react-bootstrap";

function Carousel() {
  let imgArray = [
    c1,c2,c3,c4,c5,c6,c7,c8,
    m1,m2,m3,m4,m5,m6,m7,m8,
  ];
  useEffect(() => {
    //prefetching
    imgArray.forEach((pic) => {
      const img = new Image();
      img.src = pic;
    });
  }, []);

  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    infinite: true,
  };

  const desktopArray = [c1, c2, c3, c4, c5, c6, c7, c8];
  const mobileArray = [m1, m2, m3, m4, m5, m6, m7, m8];
  return (
    <>
      <div className="carousel-desktop">
        <Slider {...settings}>
          {desktopArray.map((pic, index) => (
            <div key={`carousel${index}`}>
              <img src={pic} width={"100%"} alt={`carousel${index}`}></img>
            </div>
          ))}
        </Slider>
      </div>

      <div className="carousel-mobile">
        <Slider {...settings}>
          {mobileArray.map((pic, index) => (
            <div key={`carousel${index}`}>
              <img src={pic} width={"100%"} alt={`carousel${index}`}></img>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}

export default Carousel;
